import React from "react";
import { Stack, StackProps } from "@mui/material";

const BNStack: React.FC<StackProps> = (props) => {
  return <Stack {...props} />;
};
export default BNStack;
